import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { primaryCategoryRepository } from '@webapp/platform/organization-management/data-access/repositories/PrimaryCategoryRepository'
import { primaryCategoryKeys } from '@webapp/platform/organization-management/data-access/repositories/PrimaryCategoryRepository/queryKey.factory'
import { PrimaryCategoryConfigDetail } from '@webapp/platform/organization-management/entities/PrimaryCategoryConfigDetail'

type UseQueryPrimaryCategoryConfigDetailReturn = {
  config: PrimaryCategoryConfigDetail | null
  isFetching: boolean
  isLoading: boolean
  isError: boolean
  error: unknown
}

export const useQueryPrimaryCategoryConfigDetail = ({
  id,
  onError,
}: {
  id: number
  onError?: (error: unknown) => void
}): UseQueryPrimaryCategoryConfigDetailReturn => {
  const { data, isFetching, isLoading, isError, error } = useQuery({
    queryKey: primaryCategoryKeys.configDetail(id),
    queryFn: () => primaryCategoryRepository.getConfigById(id),
    enabled: !!id,
    onError,
  })

  const config = useMemo(() => {
    if (!data) return null
    return new PrimaryCategoryConfigDetail(data)
  }, [data])

  return {
    config,
    isFetching,
    isLoading,
    isError,
    error,
  }
}
